import { APIDefinition } from '@fullstory/library-ui';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { APIEventTooltipContent } from '../APIEventTooltipContent';

interface APIDefinitionProps {
  apiEventName: string;
}

export const APIEventDefinition: FC<APIDefinitionProps> = ({ apiEventName }) => {
  const intl = useIntl();
  return (
    <APIDefinition
      data-component="APIEventDefinition"
      name={apiEventName}
      objectType="customEvent"
      label={intl.formatMessage({ defaultMessage: 'API Event', id: 'XOChST' })}
      tooltipContent={APIEventTooltipContent}
    />
  );
};
